import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, inject } from '@angular/core';
import * as AutoNumeric from 'autonumeric';
import { VariablesGlobalesService } from 'src/app/services/variables-globales.service';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow, Platform } from "@ionic/angular/standalone";
import { CommonModule, NgStyle } from '@angular/common';
import {addIcons} from 'ionicons';
import { add, remove } from 'ionicons/icons';

@Component({
    selector: 'app-input-autonumeric',
    templateUrl: './input-autonumeric.component.html',
    styleUrls: ['./input-autonumeric.component.scss'],
    standalone: true,
    imports : [ IonGrid, IonRow,IonCol, IonIcon , IonButton , NgStyle]
})
export class InputAutonumericComponent implements OnInit  {
  variablesGlobales = inject(VariablesGlobalesService);
  platform = inject(Platform);

  @ViewChild('unidadesInput', { static: false }) unidadesInput: ElementRef;
  @Input() numUnidades: number;
  numUnidadesStr: string;
  @Input() options;
  @Output() cambiadasUnidades = new EventEmitter();
  private autoNumericInstance: AutoNumeric;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {
    addIcons({add, remove});
   }

  ngOnInit() {}
  ngAfterViewInit() {
    console.log(this.variablesGlobales.optionsInputUnidades);

    // Crear una instancia de AutoNumeric y aplicar al elemento
    this.autoNumericInstance = new AutoNumeric(this.unidadesInput.nativeElement, this.options);
    this.autoNumericInstance.set(this.numUnidades);
    this.unidadesInput.nativeElement.addEventListener('input', () => {
      this.numUnidadesStr = this.autoNumericInstance.getFormatted();
      this.numUnidades = this.autoNumericInstance.getNumber();
      this.cambiadasUnidades.emit({'numUnidades':this.numUnidades, 'numUnidadesStr': this.numUnidadesStr});
    });
  }

  getValue(): number {
    return this.autoNumericInstance.getNumber();
  }

  anadirUnidad() {
    this.numUnidades = this.autoNumericInstance.getNumber()+1;
    this.autoNumericInstance.set(this.autoNumericInstance.getNumber()+1,this.options);
    this.unidadesInput.nativeElement.focus();
    this.numUnidadesStr = this.autoNumericInstance.getFormatted();
    this.cambiadasUnidades.emit({'numUnidades':this.numUnidades, 'numUnidadesStr': this.numUnidadesStr});


  }

  quitarUnidad() {
    this.numUnidades = this.autoNumericInstance.getNumber()-1;
    this.autoNumericInstance.set(this.autoNumericInstance.getNumber()-1,this.options);
    this.unidadesInput.nativeElement.focus();
    this.numUnidadesStr = this.autoNumericInstance.getFormatted();
    this.cambiadasUnidades.emit({'numUnidades':this.numUnidades, 'numUnidadesStr': this.numUnidadesStr});
  }

}
